module.exports = __webpack_public_path__ + "static/img/login-bg.c12418d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/login-bg.jpg
// module id = WKKh
// module chunks = 1